export const STAGE_INITIAL = 'INITIAL';
export const STAGE_INTERNAL_SELECT = 'INTERNAL_SELECT';
